var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBackButtonIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 19,
    viewBox: "0 0 21 19",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.25 10.25H.75a.75.75 0 0 1 0-1.5h19.5a.75.75 0 0 1 0 1.5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9 18.5a.753.753 0 0 1-.531-.219l-8.25-8.25a.752.752 0 0 1 0-1.062l8.25-8.25a.752.752 0 0 1 1.062 0 .752.752 0 0 1 0 1.062L1.811 9.5l7.72 7.719A.752.752 0 0 1 9 18.5"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackButtonIcon);
export default __webpack_public_path__ + "static/media/back-button-icon.e4fb61d197c5b9c57ac9ee4c373fe737.svg";
export { ForwardRef as ReactComponent };